// Major US Cities
// Photos will be loaded dynamically from Google Maps Places API
export const US_CITIES = [
  {
    id: 'new-york',
    name: 'New York',
    state: 'NY',
    properties: 156
  },
  {
    id: 'los-angeles',
    name: 'Los Angeles',
    state: 'CA',
    properties: 142
  },
  {
    id: 'chicago',
    name: 'Chicago',
    state: 'IL',
    properties: 98
  },
  {
    id: 'houston',
    name: 'Houston',
    state: 'TX',
    properties: 87
  },
  {
    id: 'phoenix',
    name: 'Phoenix',
    state: 'AZ',
    properties: 72
  },
  {
    id: 'philadelphia',
    name: 'Philadelphia',
    state: 'PA',
    properties: 64
  },
  {
    id: 'san-antonio',
    name: 'San Antonio',
    state: 'TX',
    properties: 55
  },
  {
    id: 'san-diego',
    name: 'San Diego',
    state: 'CA',
    properties: 78
  },
  {
    id: 'dallas',
    name: 'Dallas',
    state: 'TX',
    properties: 91
  },
  {
    id: 'austin',
    name: 'Austin',
    state: 'TX',
    properties: 84
  },
  {
    id: 'miami',
    name: 'Miami',
    state: 'FL',
    properties: 95
  },
  {
    id: 'seattle',
    name: 'Seattle',
    state: 'WA',
    properties: 73
  },
  {
    id: 'boston',
    name: 'Boston',
    state: 'MA',
    properties: 66
  },
  {
    id: 'denver',
    name: 'Denver',
    state: 'CO',
    properties: 71
  },
  {
    id: 'las-vegas',
    name: 'Las Vegas',
    state: 'NV',
    properties: 62
  }
];

